import * as React from 'react';
import { useTabs } from './TabContext';

// Styles.
import { StyledTab, BaseStyleProps } from './Tabs.style';

export interface ITabProps extends BaseStyleProps {
  /**
   * Unique label of Tab to show when clicked.
   */
  label: string;

  /**
   * Whether the Tab should be disabled or not.
   *
   * @default false
   */
  disabled?: boolean;

  children?: React.ReactNode;

  id?: string;
}

/**
 * Tab which allows changing of the active Tab.
 */
const Tab: React.FC<ITabProps> = ({ label, children, id, ...rest }) => {
  const { onClick, activeTab, fullWidth } = useTabs();
  const active = activeTab === label;
  return (
    <StyledTab
      id={id}
      kind="text"
      role="tab"
      fullWidth={fullWidth}
      active={active}
      aria-selected={active}
      aria-controls={label}
      onClick={() => {
        onClick(label);
      }}
      {...rest}
    >
      {children}
    </StyledTab>
  );
};

Tab.defaultProps = {
  disabled: false
};

export default Tab;
